// extracted by mini-css-extract-plugin
export default {"green":"#a4ffaf","white":"#e6e5ea","veryDarkGrey":"#18171f"};